import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstaclePulseBehavior extends ObstacleBehavior {
  private time: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstaclePulse', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed * 5; // Pulse is faster
    const t = (Math.sin(this.time) + 1) / 2;
    const scale = this.config.scaleRange.min + t * (this.config.scaleRange.max - this.config.scaleRange.min);
    this.mesh.scaling.setAll(scale);
  }
  clone(): ObstaclePulseBehavior {
    return new ObstaclePulseBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
